import { render, staticRenderFns } from "./GyroChartApx.vue?vue&type=template&id=85caa8f2&"
import script from "./GyroChartApx.vue?vue&type=script&lang=js&"
export * from "./GyroChartApx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports